<template>
  <v-dialog v-model="modal" max-width="600">
    <v-form ref="form">
      <v-card>
        <v-card-title> Demande de numérisation </v-card-title>
        <v-card-text>
          <p>Vous êtes sur le point d'effectuer une demande de numérisation.</p>
          <p>
            Vous ne pouvez faire qu'une seule demande de numérisation à la fois sur les
            associations pour lesquelles vous n'avez pas de rattachement. Confirmez-vous
            vouloir faire cette demande de numérisation ?
          </p>
          <p>
            Si oui, vous ne pourrez réaliser une autre demande qu'une fois la première
            traitée.
          </p>
          <p>
            Vous serez notifié par courriel lors du traitement de vos demandes et vous
            pourrez consulter les documents associés dans l'onglet "DOCUMENTS".
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn data-testid="valider-demande-numerisation" ref="non" color="primary" @click="demande" :loading="working">
            Valider
          </v-btn>
          <v-btn data-testid="annuler-demande-numerisation" @click="ferme" :disabled="working">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import makeRemoteWorker from "@/mixins/makeRemoteWorker";
import makeRules from "@/mixins/makeRules";
import { associationService } from "@/services";

export default {
  mixins: [makeRules({ inject: false }), makeRemoteWorker({ provide: false })],
  data() {
    return {
      association: null,
      modal: false,
    };
  },
  methods: {
    ouvre(association, callback) {
      this.association = association;
      this.callback = callback;
      this.modal = true;
    },
    ferme() {
      this.modal = false;
    },
    demande() {
      this.doWork({
        forms: [this.$refs.form],
        work() {
          return associationService.demandeNumerisation(this.association);
        },
        callback(etat) {
          this.ferme();
          this.callback(etat);
        },
        successText: "La demande de numérisation a été envoyée.",
        errorText: "Erreur durant l'envoi de la demande de numérisation.",
      });
    },
  },
};
</script>
